import React from 'react';
import PropTypes from 'prop-types';
import { CarouselMedia } from '../../Generic/Carousel';
import Typography from '../../Generic/Typography';
import { getButton, getImageButton } from '../../../utils/uiHelper';
import { getCdnImage } from '../../../utils/ImageManager';
import getCdnSrcset from '../../../utils/srcSetHelper';
import i18nMessages from '../../../constants/messages/pt-BR';
import DOMPurify from 'isomorphic-dompurify';

const CarouselPanel = props => {
  const { panel } = props;
  return (
    panel && (
      <div>
        <div>
          {panel.image && (
            <CarouselMedia
              image={
                panel.image.smartphoneImage &&
                getCdnImage(panel.image.smartphoneImage.url, { w: 767 })
              }
              component="img"
              srcset={getCdnSrcset(
                panel.image.desktopImage && panel.image.desktopImage.url,
                1600,
                768
              )}
              alt={panel.image.altText}
            />
          )}
        </div>
        <div>
          <div>
            {panel.title && (
              <Typography
                component="div"
                dangerouslySetInnerHTML={{
                  __html:DOMPurify.sanitize( panel.title),
                }}
              />
            )}
            {panel.text && (
              <Typography
                component="div"
                dangerouslySetInnerHTML={{
                  __html:DOMPurify.sanitize( panel.text),
                }}
              />
            )}
          </div>
          <div>
            {panel.callToActionCollection &&
              panel.callToActionCollection.items.map(action => {
                if (action) {
                  switch (action.__typename) {
                    case i18nMessages.LinkButton:
                      return getButton(action);
                    case i18nMessages.ImageButton:
                      return getImageButton(action);
                    default:
                      return null;
                  }
                }
              })}
          </div>
        </div>
      </div>
    )
  );
};

CarouselPanel.propTypes = {
  panel: PropTypes.oneOfType([PropTypes.object]).isRequired,
};
export default CarouselPanel;
